import React from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'

type ScrollNavigationProps = {
    onPrevious: () => void
    onNext: () => void
    canScrollPrevious: boolean
    canScrollNext: boolean
    size?: 'small' | 'large'
    className?: string
}

/**
 * Shared previous/next controls for horizontally scrollable UI modules.
 * The compact size is intended for option rows; the large size suits page modules.
 */
const ScrollNavigation: React.FC<ScrollNavigationProps> = ({
    onPrevious,
    onNext,
    canScrollPrevious,
    canScrollNext,
    size = 'large',
    className = '',
}) => {
    const isLarge = size === 'large'
    const buttonClassName = isLarge
        ? 'w-12 h-12 bg-gray-100 hover:bg-gray-200'
        : 'w-6 h-6 bg-gray-100 hover:bg-gray-200'
    const iconClassName = isLarge ? 'w-6 h-6' : 'w-4 h-4'

    return (
        <div className={`flex shrink-0 ${isLarge ? 'gap-3' : 'gap-1'} ${className}`}>
            <button
                type="button"
                onClick={onPrevious}
                className={`${buttonClassName} rounded-full flex items-center justify-center text-gray-700 transition-colors disabled:opacity-30 disabled:cursor-not-allowed`}
                disabled={!canScrollPrevious}
                aria-label="Scroll left"
            >
                <ChevronLeft className={iconClassName} />
            </button>
            <button
                type="button"
                onClick={onNext}
                className={`${buttonClassName} rounded-full flex items-center justify-center text-gray-700 transition-colors disabled:opacity-30 disabled:cursor-not-allowed`}
                disabled={!canScrollNext}
                aria-label="Scroll right"
            >
                <ChevronRight className={iconClassName} />
            </button>
        </div>
    )
}

export default ScrollNavigation
